export default __webpack_public_path__ + "static/media/ts-2.3dddc6bc.jpg";